import httpClient from "./httpClient";

const base = "/exam-remarks-templates";

export function listRemarksTemplates() {
  return httpClient.get(base).then((res) => res.data.data);
}

export function createRemarksTemplate(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function updateRemarksTemplate(id, payload) {
  return httpClient.put(`${base}/${id}`, payload).then((res) => res.data.data);
}

export function deleteRemarksTemplate(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}

export function saveExamRemarks(payload) {
  return httpClient.put("/exam-results/remarks", payload).then((res) => res.data);
}
